/**
 * Scrap metal. Heavy, worthless per kilo, and stackable: the item that makes a full backpack a
 * decision about what to leave behind.
 */

import type { JunkItem } from '@/sim/items/itemContract';

export const SCRAP_METAL = {
  id: 'scrapMetal',
  kind: 'junk',
  label: 'Scrap metal',
  description: 'Was a Bureau filing cabinet. Records retention policy has been fully satisfied.',
  rarity: 'common',
  weightKg: 0.6,
  stackLimit: 20,
  equip: null,
  scrapValue: 4,
} as const satisfies JunkItem;
